module.exports = __webpack_public_path__ + "d806464536149b11b9c337df637b3e04.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/camera.png
// module id = 32
// module chunks = 0